import * as extraActions from './backbone.extraActions';

import { STATUS_ERROR, STATUS_LOADING, STATUS_SUCCESS } from 'constants/statuses.constants';

const fetchBackboneData = ({ pending, fulfilled, rejected }) => ({
  [pending]: (state) => {
    state.status = STATUS_LOADING;
    state.error = null;
  },
  [fulfilled]: (state, action) => {
    const { backboneData } = action.payload;
    state.backboneData = backboneData;
    state.status = STATUS_SUCCESS;
    state.error = null;
  },
  [rejected]: (state, action) => {
    const { error } = action.payload;
    state.status = STATUS_ERROR;
    state.error = error;
  },
});

const fetchMHCAlleles = ({ pending, fulfilled, rejected }) => ({
  [pending]: (state) => {
    state.status = STATUS_LOADING;
    state.error = null;
  },
  [fulfilled]: (state, action) => {
    const { mhcAlleles } = action.payload;
    state.mhcAlleles = mhcAlleles;
    state.status = STATUS_SUCCESS;
    state.error = null;
  },
  [rejected]: (state, action) => {
    const { error } = action.payload;
    state.status = STATUS_ERROR;
    state.error = error;
  },
});

export const reducers = {};
export const extraReducers = {
  ...fetchBackboneData(extraActions.fetchBackboneData),
  ...fetchMHCAlleles(extraActions.fetchMHCAlleles),
};
